module.exports = "/_next/static/images/danamon-icon-1d7f0a2db490685884f8779968d7ed7c.svg";